import { PageHeaderLink } from '@amzn/stencil-react-components/page';
import { Link } from 'react-router-dom';

const PageHeaderRouterLink = PageHeaderLink.withComponent(Link);

PageHeaderRouterLink.defaultProps = {
  ...PageHeaderLink.defaultProps,
};

export default PageHeaderRouterLink;
